import { createFileRoute } from "@tanstack/react-router";
import { Expertise } from "../components/sections";
import { pageHead } from "@/lib/seo";

const TITLE = "Expertise — React, Drupal, Symfony, AI | IT Solutions";
const DESC =
  "Diepe expertise in moderne front-ends, enterprise CMS (Drupal), Symfony-backends, AI-automatisering, SEO en integraties. Snelheid waar het kan, robuustheid waar het moet.";

import { ExpertisePage } from "@/pages/expertise";

export const Route = createFileRoute("/expertise")({
  head: () =>
    pageHead({ lang: "nl", pathWithoutLang: "/expertise", title: TITLE, description: DESC }),
  component: ExpertisePage,
});
